import { generateAutomationName } from "../../../../../../helpers/generateAutomationName";

export const collisionItemKeys = {
    container: generateAutomationName("home", ["topics", "modal", "collision", "item", "container"]),
    title: generateAutomationName("home", ["topics", "modal", "collision", "item", "title"]),
    name: generateAutomationName("home", ["topics", "modal", "collision", "item", "name"]),
    input: generateAutomationName("home", ["topics", "modal", "collision", "item", "inpu"]),
};
